import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Statement from "@/components/Statement";
import Services from "@/components/Services";
import LiveTour from "@/components/LiveTour";
import Process from "@/components/Process";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { TOUR_REDIRECTS } from "@/data";

export default function App() {
    const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
    const redirectUrl = TOUR_REDIRECTS[pathname];
    const isBooking = pathname === "/book";
    const tours = {
  "/tour/mosaic-mansion": "https://kuula.co/share/collection/7dGM6?logo=-1&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.02&thumbs=-1",
  "/tour/baldwin-hills": "https://kuula.co/share/collection/7dp7V?logo=-1&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.02&thumbs=-1",
};

const tourUrl = tours[pathname];
    useEffect(() => {
        if (redirectUrl) {
            window.location.replace(redirectUrl);
            return;
        }
        const lenis = new Lenis({ duration: 1.35, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        const hash = window.location.hash.slice(1);
        const hashFrame = requestAnimationFrame(() => {
            const target = hash && document.getElementById(hash);
            if (target) lenis.scrollTo(target, { immediate: true });
        });
        return () => {
            cancelAnimationFrame(hashFrame);
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, [redirectUrl]);

    if (redirectUrl) return null;
    if (tourUrl) {
  return (
    <iframe
      src={tourUrl}
      title="LILIKOOP 360° Virtual Tour"
      allow="fullscreen; accelerometer; gyroscope; xr-spatial-tracking"
      allowFullScreen
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100dvh",
        border: "none",
        zIndex: 9999,
      }}
    />
  );
}

    return (
        <div className="bg-[#FBF9F5] text-[#121211] antialiased">
            <Nav />
            <main>
                {!isBooking && <>
                <Hero />
                <Marquee />
                <Statement
                    testid="statement-idea"
                    videoUrl="https://customer-assets-4nw71qhi.emergentagent.net/job_portal-spaces/artifacts/fmue1t0v_Top%20down%20Palm%20Springs%281%29.mp4"
                    eyebrow="The idea"
                    lines={[
                        { text: "Let them in." },
                        { text: "Before they", indent: true },
                        { text: "come in.", italic: true, indent: true },
                    ]}
                    note="Anyone can walk through a space — inside and out — and understand its layout, light, scale and atmosphere long before they arrive."
                />
                <LiveTour />
                <Process />
                <Portfolio />
                <Services />
                <About />
                <Statement
                    testid="statement-competitors"
                    eyebrow="The argument"
                    lines={[
                        { text: "Let them in." },
                        { text: "Before your", indent: true },
                        { text: "competitors do.", italic: true, indent: true },
                    ]}
                    note="Your space is worth exploring. Let's turn it into an experience."
                    cta="Start a project"
                />
                </>}
                <Contact />
            </main>
            <Footer />
            <Toaster position="bottom-right" />
        </div>
    );
}
